<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <div id="map" class="map"></div>
    <c-detail
      v-if="JSON.stringify(poisiton) !== '{}'"
      :form="poisiton"
      class="detail"
    ></c-detail>
  </div>
</template>

<script>
//畜牧业map
// import Vue from "vue";
import * as L from "leaflet";
import "proj4";
import "proj4leaflet";
const esri = require("esri-leaflet");
import "leaflet/dist/leaflet.css";
// import changeMap from "../util/changeMap";
import { findPigTzNum, findPigTzTjArea } from "@/api/granary";
import { snqyMixin } from "@/util/mixin/snqyMixin";
import { get } from "@/api/index";
export default {
  mixins: [snqyMixin],
  data() {
    return {
      curName: "检疫开证点", //当前加载分布名称
      nowZoom: 0,
      qypopup: null, // 信息弹出
      type: "",
      map: null,
      daiArr: [],
      jdArr: [],
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      poisiton: {},
      pointList: [],
      hoverArr: [],
      baseList: [],
      beltObj: {},
      areaList: [],
      pointAnchor: [-10, 50],
      baseAnchor: [13, 36],
      mianArr: []
    };
  },
  mounted() {
    this.$bus.$on("zlchange", val => {
      this.poisiton = {};
      this.curName = val;
      if (val == "检疫开证点") {
        this.dataLoad(0);
      } else if (val == "生猪屠宰开证") {
        this.dataLoad(1);
      } else if (val == "生猪屠宰猪只") {
        this.dataLoad(2);
      } else if (val == "生猪屠宰猪产品") {
        this.dataLoad(3);
      } else if (val === "龙头企业") {
        this.snqyDataload(3);
      } else if (val === "合作社") {
        this.snqyDataload(4);
      } else if (val === "家庭农场") {
        this.snqyDataload(5);
      } else if (val === "农资经营企业") {
        this.snqyDataload(6);
      } else if (val === "生产基地") {
        this.snqyDataload(7);
      }
    });
    this.initMap();
  },
  methods: {
    initMap() {
      // 加载底图
      let tileMapUrl = this.$config.tileMapUrlColor;
      let CRS_4490 = new L.Proj.CRS(
        "EPSG:4490",
        "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs",
        {
          resolutions: this.$config.resolutions,
          origin: [-400.0, 399.9999999999998]
        }
      );

      var map = L.map("map", {
        crs: CRS_4490,
        minZoom: this.$config.sZoom,
        maxZoom: this.$config.mZoom,
        zoomControl: false
      });
      this.map = map; //data上需要挂载
      window.map = map;
      let tileMapLayer = esri.tiledMapLayer({
        url: tileMapUrl
      });
      tileMapLayer.addTo(map);
      //   setTimeout(() => {
      // eslint-disable-next-line no-undef
      // $(".leaflet-control-attribution").empty();
      //   }, 300);
      this.map.setView(
        L.latLng(this.$config.sLat, this.$config.sLng),
        this.nowZoom
      );

      this.dataLoad(0);
      map.on("click", e => {
        console.log(e.latlng);
        this.poisiton = {};
      });
      map.on("zoom", () => {
        this.nowZoom = this.map.getZoom();
        if (this.curName === "检疫开证点") {
          if (this.nowZoom > 0) {
            this.loadJykzd();
          } else {
            this.dataLoad(0);
          }
        }
        this.poisiton = {};
      });
      map.on("move", () => {
        this.poisiton = {};
      });
    },
    //加载标记点数据
    dataLoad(mode = 0) {
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
        this.baseList = [];
      }
      let unit = "个";
      if (mode == 0) {
        findPigTzNum().then(data => {
          data.data.map(ele => {
            ele.latitude = Number(ele.latitude_);
            ele.longitude = Number(ele.longitude_);
            ele.name = ele.country_ + ":" + ele.num + unit;
            this.baseList.push(ele);
          });
          this.baseLoad("zc.png", true);
        });
      } else if (mode > 0) {
        if (mode == 2) {
          unit = "只";
        } else if (mode == 3) {
          unit = "公斤";
        }
        findPigTzTjArea(mode).then(data => {
          data.data.map(ele => {
            ele.latitude = Number(ele.latitude);
            ele.longitude = Number(ele.longitude);
            ele.name = ele.name + ":" + ele.num + unit;
            this.baseList.push(ele);
          });
          this.baseLoad("zc.png", true);
        });
      }
    },
    //  加载下层数据
    loadJykzd(f = false) {
      get("/api/restful/findPigTzCompany").then(data => {
        this.baseList = []; //清空旧的数据
        data.data.forEach(ele => {
          if (!ele.name_) {
            return true;
          }
          ele.latitude = Number(ele.latitude_);
          ele.longitude = Number(ele.longitude_);
          ele.name = ele.name_;
          this.baseList.push(ele);
        });

        //   this.map.setView(L.latLng(dt.latitude, dt.longitude), 3);
        if (f) {
          this.map.setZoom(2);
        }
        this.baseLoad_h("zc.png", true);
      });
    },
    // 基地数据加载
    baseLoad(img = "zc.png", hasclick = false) {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      let pointUrl = require("images/map/" + img);
      this.baseList.map(it => {
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;
          //   let pointUrl = require("images/map/" + it.img);
          var myIcons;

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names'>" +
              it.name +
              "</span ></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          if (hasclick) {
            baseLayer.on("click", e => {
              const dt = e.sourceTarget.options.attributes;
              console.log("data ==", dt);
              if (this.curName === "检疫开证点") {
                this.loadJykzd(true);
              }
              /*               //当前点击的物体的名称
              const name = e.sourceTarget.options.attributes.name;
              // 创建ext
              let MyComponent = Vue.extend({
                template: `<div style="height:331px;"><div class="titlePan">{{name}}</div>
            <div style="width: 380px; height: 260px; padding:10px;" id="popmarker-jk10000">
            hello world!!!</div>
            </div>`,
                data() {
                  return {
                    name: name
                  };
                }
              });
              let component = new MyComponent().$mount();
              if (this.qypopup == null) {
                this.qypopup = L.popup({
                  minWidth: 400,
                  className: "jk-popup",
                  autoPanPadding: L.point(200, 152),
                  offset: L.point(12, -32)
                })
                  .setLatLng(this.getLat())
                  .openOn(this.map);
              }
              this.qypopup
                .setLatLng(L.latLng(data.latitude, data.longitude))
                .setContent(component.$el)
                .openOn(this.map); */
              // setTimeout(() => {
              //   this.echarttu_marker("-jk10000", this.cName, price, id);
              // }, 200);
              // this.$store.dispatch(
              //   "drawer/setGraphic",
              //   e.sourceTarget.options.attributes
              // );
              // this.$store.dispatch("drawer/setRightComponent", "ghmjDrawer");
            });
          }
          //   baseLayer.on("mouseover", it => {
          //     this.ncCode = it.target.options.attributes.code;
          //   });
        }
      });
      this.map.addLayer(this.basesGroup);
      //   L.marker([22.15301368697925, 110.97497423601772]).addTo(this.map);
    },

    echarttu_marker() {},
    getLat() {
      return this.map.getCenter();
    },
    baseLoad_h(img = "zc.png") {
      this.jdArr = [];
      if (this.basesGroup) {
        this.map.removeLayer(this.basesGroup);
      }
      this.basesGroup = new L.layerGroup();
      this.baseList.map(it => {
        if (it.latitude) {
          it.lat = it.latitude;
          it.lng = it.longitude;
          let pointUrl = require("images/map/" + img);
          if (it.img) {
            pointUrl = require("images/map/" + it.img);
          }
          var myIcons;

          myIcons = L.divIcon({
            html:
              "<div class='indicator-box'><img src='" +
              pointUrl +
              "' /><span class='my-div-names hide'>" +
              it.name +
              "</span></div>",
            className: "my-div-icon",
            iconAnchor: this.baseAnchor
          });

          let baseLayer = L.marker([it.lat, it.lng], {
            interactive: true,
            icon: myIcons,
            attributes: it
          }).addTo(this.basesGroup);
          this.jdArr.push(baseLayer);
          baseLayer.on("click", e => {
            const data = e.sourceTarget.options.attributes;
            console.log("data ==", data);

            this.poisiton = {};
            let obj = {};
            obj.x = e.containerPoint.x;
            obj.y = e.containerPoint.y;
            let chkArr = [
              {
                key: "province_",
                name: "省"
              },
              {
                key: "city_",
                name: "市"
              },
              {
                key: "country_",
                name: "区"
              },
              {
                key: "address_",
                name: "地址"
              },
              {
                key: "competent_",
                name: "联系人"
              },
              {
                key: "competent_phone_",
                name: "联系电话"
              },
              {
                key: "fax_",
                name: "传真"
              }
            ];
            let arr = [];
            obj.name = data.name;
            chkArr.forEach(e => {
              if (data[e.key]) {
                arr.push({
                  name: e.name,
                  num: data[e.key],
                  unit: e.unit || ""
                });
              }
            });
            obj.dataList = arr;
            this.poisiton = obj;
            // this.$store.dispatch(
            //   "drawer/setGraphic",
            //   data
            // );
            // this.$store.dispatch("drawer/setRightComponent", "njfbDrawer");
          });
          baseLayer.on("mouseover", it => {
            // this.ncCode = it.target.options.attributes.code;
            console.log("it", it.target.options.attributes);
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.remove("hide");
          });
          baseLayer.on("mouseout", it => {
            it.sourceTarget
              .getElement()
              .querySelector(".my-div-names")
              .classList.add("hide");
          });
        }
      });
      this.map.addLayer(this.basesGroup);
    }
  },
  destroyed() {
    this.$bus.$off("zlchange");
  }
};
</script>

<style lang="stylus" scoped>
.map
    background none !important
    width 100%
    height calc(100% + 105px)
    z-index 9

    // >>>.leaflet-tile-pane
    // display none
    >>>.leaflet-bar
        display none

    >>>.leaflet-bottom
        display none

    .ncDetail
        position absolute

    >>>
        .my-div-icon
            color #fff
            // z-index 970 !important

        .indicator-box
            position relative

        .my-div-name
            font-size .08rem
            border 1px #fff solid
            border-radius 5px
            background-color rgba(15, 62, 112, .8)
            padding 2px 8px

        .my-div-name:hover
            z-index 999
            font-size .09rem

        .my-div-names.hide
            display none
        .my-div-names
            font-size .07rem
            color #4DB5FE
            position absolute
            top -36px
            left 13px
            width max-content
            padding .01rem .06rem
            border-radius 5px
            border 1px solid #4DB5FE
            background #011C46
            transform translateX(-50%)
            &:before
                content: '';
                transform: translate(-50%,0);
                position: absolute;
                bottom: -10px;
                left: 50%;
                opacity: 1;
                border-top: solid 10px #4DB5FE;
                border-right: solid 10px transparent;
                border-left: solid 10px transparent;
            &:after
                content: '';
                transform: translate(-50%,0);
                position: absolute;
                bottom: -9px;
                left: 50%;
                opacity: 1;
                border-top: solid 10px #011C46;
                border-right: solid 10px transparent;
                border-left: solid 10px transparent;
        .my-div-names.lt
            background #FF9000
            &:before
                border-top-color #FF9000
</style>
